module.exports = __webpack_public_path__ + "img/hedera.63193be5.svg";